import Serializer from 'umg-ember-backend/serializers/application';

export default class CustomShopSerializer extends Serializer {
  attrs = {
    category: 'categoryId',
    position: 'cmsPosition',
  };
}
